import { ErrorEmptyState } from '@/pages/error-pages/error-empty-state/error-empty-state'

export const CompanyNotFound = () => {
  return <ErrorEmptyState title='Sorry, company not found.' />
}
